class ProductsSlider extends HTMLElement {
    constructor() {
        super();

        const id = this.getAttribute('data-id');
        const sliderSelector = `[data-id=${id}] .splide`;

        if (document.querySelector(sliderSelector)) {
            document.addEventListener('DOMContentLoaded', function() {
                new Splide(`[data-id=${id}] .splide`, {
                    type: 'loop',
                    perPage: 4,
                    dots: false,
                    gap: '8px',
                    breakpoints: {
                    1024: {
                      perPage: 2,
                    },
                    580: {
                      perPage: 1
                    }
                  }
                  }).mount();
            });
        }
        
        this.addEventListener('click', function (e) {
            const target = e.target;

            if (target instanceof SVGElement || target.tagName == 'add-to-cart') {
                e.preventDefault();
            }
        })
    }
}
customElements.define('products-slider', ProductsSlider);